import React, {
    PropTypes,
} from 'react';
import {PortionSlider} from '../../components';
import {Glyphicon, Tooltip, OverlayTrigger} from 'react-bootstrap';

// function allergy() {
//     let tooltip = <Tooltip id={"tt"+Math.random()}>Присутствуют аллергены</Tooltip>;
//     return <span>
//         <OverlayTrigger placement="top" overlay={tooltip}>
//             <Glyphicon style={{fontSize: "1.4em", top: "0.2em", cursor: "pointer"}} glyph="alert"/>
//         </OverlayTrigger>
//         &nbsp;
//     </span>;
// }

function compose(text, color) {
    let tooltip = <Tooltip id={"tt" + Math.random()}>{text}</Tooltip>;
    const style = {fontSize: "1.4em", top: "0.2em", cursor: "pointer"};
    if (color) {
        style.color = color;
    }
    return <span>
        <OverlayTrigger placement="top" overlay={tooltip}>
            <Glyphicon className="text-success"
                       style={style}
                       glyph="info-sign"/>
        </OverlayTrigger>
        &nbsp;
    </span>;
}

const MenuItem = ({
                      waresName, /*measurementUnit,*/
                      /*composition, allergens,*/ weight,
                      isFractional, waresQuantity, cost,
                      statusText, statusColor, isReadOnly,
                      onChange, fontColor
                  }) => {
    cost = parseFloat(cost);
    waresQuantity = parseFloat(waresQuantity);
    return (
        <tr style={{verticalAlign: 'middle', background: isReadOnly === 1 ? '#efefef' : '', whiteSpace: 'pre-wrap'}}>
            <td>
                {/*{allergens ? allergy() : ''}*/}
                {onChange || statusText ? compose(statusText, statusColor) : ''}
                {fontColor ? <span style={{color: fontColor}}>{waresName}</span> : waresName}
            </td>
            <td className="hidden-xs hidden-sm text-right" style={{width: "80px"}}>{weight}</td>
            <td className="hidden-xs text-right" style={{width: "80px"}}>{cost.toFixed(2)}</td>
            <td style={{width: "115px"}} className="text-center">
                {onChange ?
                    <PortionSlider disabled={isReadOnly} onChange={onChange} partial={isFractional} initial={waresQuantity}/> :
                    waresQuantity
                }
                <div className="visible-xs-block text-center">
                    {waresQuantity && waresQuantity !== 1 ? ((cost * waresQuantity).toFixed(2) + '₴') : ''}
                    ({cost.toFixed(2)}₴ за 1)
                </div>
            </td>
            <td className="hidden-xs text-right" style={{width: "80px"}}>{(cost * waresQuantity).toFixed(2)}</td>
        </tr>
    );
};

MenuItem.propTypes = {
    onChange: PropTypes.func,
};

export default MenuItem;



/** WEBPACK FOOTER **
 ** ./src/modules/food/MenuItem.js
 **/